var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('v-col',{attrs:{"cols":"10"}},[_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }